import { entityApiCall } from '../services'
import { AnyType, IOrderBy, IPredicate } from '@centra/centra-ui'
import { getStorageUrl } from '../utils'

export const fetchClientProducts = (predicates: IPredicate[], ordering: IOrderBy[]) => {
  return entityApiCall({
    method: 'POST',
    url: '/ng/v1/reportClientProduct/get',
    data: {
      selector: {
        fields: [
          'productId',
          'productName',
          'productLogo',
          'productNewLogo',
          'productVendor',
          'clientId',
          'clientName',
          'clientLogo',
          'agencyId',
          'productTypeId',
          'productTypeName',
          'productTypeAlias',
          'productCabinets',
        ],
        predicates,
        ordering,
      },
    },
  }).then(resp => {
    if (resp?.data?.page?.entries) {
      resp?.data?.page?.entries?.forEach((entry: AnyType) => {
        if (entry.productNewLogo) {
          entry.productLogo = entry.productNewLogo.imageSizeUrls.main
        } else {
          entry.productLogo = getStorageUrl('product-logo', entry.productLogo, true)
        }
      })
    }

    return resp
  })
}
